import { FeatureFlag } from '@ps/web-core-enums';
import { takeUntil } from 'rxjs/operators';

import type { WidgetEffectParams } from '@swf/core/store';
import { authChange } from '@swf/core/utils/actions';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { SportsPromotionWidgetConfig } from '../config';

import type { PromotionContentResponse, WidgetDispatch } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    {
      actions,
      dispatch,
      widget,
      select,
      rootState
    }: WidgetEffectParams<SportsPromotionWidgetConfig>
  ) {
    const { promotionInfoRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    if (!select[widget.uid].hasPreloaded(rootState)) {
      await promotionInfoRequested();
    }

    const authChangeAction = authChange(actions);

    if (authChangeAction) {
      authChangeAction.pipe(takeUntil(widget.unmount)).subscribe({
        next: () => {
          promotionInfoRequested();
        },
        complete: () => clear()
      });
    }
  },

  async promotionInfoRequested(
    _payload: undefined,
    params: WidgetEffectParams<SportsPromotionWidgetConfig>
  ) {
    const { dispatch, request, widget, rootState, select } = params;
    const { zoneId } = widget;
    const isEligibleForPromotions = select.feature.check(rootState, FeatureFlag.ISPPromotions);

    if (!isEligibleForPromotions) {
      dispatch[widget.uid].promotionLoaded(null);
      return;
    }

    try {
      const { body }: PromotionContentResponse = await request({
        service: 'crm.zone',
        body: { zoneId },
        signal: getWidgetCancellationSignal(params)
      });
      dispatch[widget.uid].promotionLoaded(body.contents?.[0]);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      dispatch[widget.uid].promotionLoadFailed();
    }
  }
};
